var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "provider-wrapper" }, [
    _c("span", [_vm._v("\n        " + _vm._s(_vm.provider.type) + "\n    ")]),
    _vm._v(" "),
    _c("span", { staticClass: "provider-wrapper__info" }, [
      _c(
        "span",
        { staticClass: "provider-wrapper__icon" },
        [_c("icon-" + _vm.provider.icon, { tag: "component" })],
        1
      ),
      _vm._v("   \n        " + _vm._s(_vm.provider.label) + "\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }